/**
 * Constants for website environments.
 * NOTE: These are duplicated in next.config.js and should be kept in sync.
 */
const SITE_ENVIRONMENTS = {
  ACHIEVE: 'achieve',
  FDR: 'website-fdr',
  FFN: 'website-ffn',
  WFS: 'website-wfs',
  DEFAULT: 'achieve',
}

const PAGE_LIST = {
  default: {
    websiteField: 'Achieve',
  },
  achieve: {
    websiteField: 'Achieve',
  },
  'website-wfs': {
    websiteField: 'Weekly Financial Solutions',
  },
  'website-fdr': {
    websiteField: 'Freedom Debt Relief',
  },
  'website-ffn': {
    websiteField: 'Freedom Financial Network',
  },
}

const WEBSITEFIELD_TO_HOST_MAP = {
  default: {
    host: 'https://www.achieve.com',
  },
  Achieve: {
    host: 'https://www.achieve.com',
  },
  'Weekly Financial Solutions': {
    websiteField: 'Weekly Financial Solutions',
    host: 'https://www.weeklyfinancialsolutions.com',
  },
  FDR: {
    websiteField: 'FDR',
    host: 'https://www.freedomdebtrelief.com',
  },
  'Freedom Debt Relief': {
    websiteField: 'Freedom Debt Relief',
    host: 'https://www.freedomdebtrelief.com',
  },
  'Freedom Financial Network': {
    websiteField: 'Freedom Financial Network',
    host: 'https://www.freedomfinancialnetwork.com',
  },
}

export { SITE_ENVIRONMENTS, PAGE_LIST, WEBSITEFIELD_TO_HOST_MAP }
export default SITE_ENVIRONMENTS
